import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import UatPasswordGate from './components/UatPasswordGate';

// Suppress websocket errors from showing in React error overlay
// These are expected when the backend is not running or during reconnection

// In development mode, suppress React's error overlay for websocket errors
if (process.env.NODE_ENV === 'development') {
  // Patch console.error to suppress websocket errors
  const originalConsoleError = console.error;
  console.error = (...args) => {
    const message = args[0]?.toString() || '';
    if (message.includes('websocket') || 
        message.includes('WebSocket') ||
        message.includes('ws.onerror') ||
        message.includes('ws.onError') ||
        message.includes('xhr poll error') ||
        message.includes('poll error') ||
        message.includes('transport error')) {
      console.warn('Suppressed websocket console.error:', ...args);
      return;
    }
    originalConsoleError.apply(console, args);
  };

  // Dismiss the React error overlay when it shows websocket errors
  const dismissWebsocketErrors = () => {
    const overlay = document.getElementById('webpack-dev-server-client-overlay');
    if (overlay) {
      const content = overlay.textContent || '';
      if (content.includes('websocket') || content.includes('WebSocket') || content.includes('ws.on') ||
          content.includes('xhr poll error') || content.includes('poll error')) {
        overlay.style.display = 'none';
        console.warn('Dismissed React error overlay for websocket error');
      }
    }
  };

  // Check periodically for the error overlay
  setInterval(dismissWebsocketErrors, 100);
  
  // Also observe DOM changes to catch the overlay when it appears
  const observer = new MutationObserver(dismissWebsocketErrors);
  observer.observe(document.documentElement, { childList: true, subtree: true });
}

window.addEventListener('error', (event) => {
  const message = event.message || event.error?.message || '';
  if (message.includes('websocket') || 
      message.includes('WebSocket') ||
      message.includes('socket') ||
      message.includes('ECONNREFUSED') ||
      message.includes('connect ECONNREFUSED') ||
      message.includes('xhr poll error') ||
      message.includes('poll error') ||
      message.includes('transport error')) {
    event.preventDefault();
    event.stopPropagation();
    console.warn('Suppressed websocket error:', message);
    return true;
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason?.message || String(event.reason || '');
  if (reason.includes('websocket') || 
      reason.includes('WebSocket') ||
      reason.includes('socket') ||
      reason.includes('ECONNREFUSED') ||
      reason.includes('No authentication token') ||
      reason.includes('xhr poll error') ||
      reason.includes('poll error') ||
      reason.includes('transport error')) {
    event.preventDefault();
    event.stopPropagation();
    console.warn('Suppressed websocket promise rejection:', reason);
    return true;
  }
}, true);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UatPasswordGate>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </UatPasswordGate>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
